module.exports = __webpack_public_path__ + "img/selected3-min.482c6d54.png";